(function(){
  'use strict';
  var X = window.XTEC || {};
  function money(cents){
    var fmt = X.moneyFormat || '£{{amount}}';
    var n = (cents/100);
    var withDec = n.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
    var noDec = Math.round(n).toLocaleString('en-GB');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,withDec.replace('.',',')).replace(/\{\{\s*amount\s*\}\}/,withDec);
  }
  var toast = document.getElementById('toast'), tt;
  function say(m){ if(!toast) return; toast.textContent=m; toast.classList.add('on'); clearTimeout(tt); tt=setTimeout(function(){toast.classList.remove('on')},2600); }

  /* cart count */
  function refreshCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=c.item_count});
      document.querySelectorAll('[data-cart-total]').forEach(function(e){e.textContent=money(c.total_price)});
      document.querySelectorAll('[data-cart-items]').forEach(function(e){e.textContent=c.item_count+(c.item_count===1?' item':' items')});
    }).catch(function(){});
  }
  function addToCart(id,qty,title,btn){
    if(btn){btn.disabled=true;}
    return fetch((X.routes&&X.routes.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){ say(res.j.description||res.j.message||'Sorry, this item could not be added.'); return; }
        say('Added to basket: '+(title||(res.j.items&&res.j.items[0]&&res.j.items[0].product_title)||'item'));
        if(btn){var t=btn.textContent;btn.textContent='Added';btn.classList.add('done');setTimeout(function(){btn.textContent=t;btn.classList.remove('done')},1600);}
        return refreshCart();
      })
      .catch(function(){ say('Sorry, something went wrong. Please try again.'); })
      .finally(function(){ if(btn){btn.disabled=false;} });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-variant]'); if(!b) return;
    e.preventDefault(); addToCart(b.getAttribute('data-add-variant'),1,b.getAttribute('data-title'),b);
  });

  /* mega menu */
  var allBtn=document.getElementById('allBtn'), mega=document.getElementById('mega');
  function setMega(o){ if(!mega||!allBtn) return; mega.classList.toggle('open',o); allBtn.setAttribute('aria-expanded',o); if(o){var r=allBtn.getBoundingClientRect(); mega.style.top=r.bottom+'px';} }
  if(allBtn){
    allBtn.addEventListener('click',function(e){e.stopPropagation();setMega(!mega.classList.contains('open'))});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')setMega(false)});
    document.addEventListener('click',function(e){if(!e.target.closest('#mega'))setMega(false)});
    window.addEventListener('scroll',function(){if(mega.classList.contains('open'))setMega(true)},{passive:true});
  }

  /* search with category */
  var sf=document.getElementById('searchForm');
  if(sf){ sf.addEventListener('submit',function(){
    var sel=sf.querySelector('[data-search-type]'), q=sf.querySelector('input[name=q]');
    if(sel&&sel.value&&q){ var terms=q.value.trim(); q.value=(terms?terms+' AND ':'')+'product_type:"'+sel.value+'"'; }
  }); }

  /* product rows */
  document.querySelectorAll('.rowwrap').forEach(function(w){
    var row=w.querySelector('[data-row]'), prev=w.querySelector('.rnav.prev'), next=w.querySelector('.rnav.next');
    if(!row||!prev||!next) return;
    var step=function(){return Math.max(row.clientWidth*0.9,200)};
    prev.addEventListener('click',function(){row.scrollBy({left:-step()})});
    next.addEventListener('click',function(){row.scrollBy({left:step()})});
    var upd=function(){var max=row.scrollWidth-row.clientWidth-4; prev.disabled=row.scrollLeft<=4; next.disabled=row.scrollLeft>=max; w.classList.toggle('at-end',row.scrollLeft>=max)};
    row.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd(); setTimeout(upd,400);
  });

  /* footer accordions on mobile */
  var mq=window.matchMedia('(max-width:640px)');
  var setF=function(){document.querySelectorAll('.fcol').forEach(function(d){d.open=!mq.matches})};
  setF(); if(mq.addEventListener) mq.addEventListener('change',setF);
  document.querySelectorAll('.fcol summary').forEach(function(s){s.addEventListener('click',function(e){if(!mq.matches)e.preventDefault()})});

  /* collection filters: submit on change */
  var ff=document.getElementById('FacetsForm');
  if(ff){ ff.addEventListener('change',function(e){ if(e.target.matches('input[type=checkbox],select')) ff.submit(); }); }

  /* product page */
  var root=document.querySelector('[data-product-root]');
  if(root){
    var dataEl=document.querySelector('[data-product-json]'), data=dataEl?JSON.parse(dataEl.textContent):{variants:[],grades:{}};
    var form=root.querySelector('[data-product-form]'), idIn=root.querySelector('[data-variant-id]'), priceEl=root.querySelector('[data-price]'), cmpEl=root.querySelector('[data-compare]'),
        stockEl=root.querySelector('[data-stock]'), btn=root.querySelector('[data-add-btn]'), skuEl=root.querySelector('[data-sku]'), gdesc=root.querySelector('[data-grade-desc]'), mainImg=document.getElementById('MainImage');
    function current(){
      var sel=[]; root.querySelectorAll('input[data-option]:checked').forEach(function(i){sel[+i.getAttribute('data-option')]=i.value});
      if(!sel.length) return data.variants[0];
      return data.variants.find(function(v){return v.options.every(function(o,i){return sel[i]===undefined||o===sel[i]})});
    }
    function gradeText(v){ if(!gdesc||!v) return; var g=v.options.find(function(o){return data.grades[o]}); gdesc.textContent=g?data.grades[g]:''; }
    function update(){
      var v=current(); if(!v){ if(btn){btn.disabled=true;btn.textContent='Unavailable';} return; }
      idIn.value=v.id;
      priceEl.textContent=money(v.price); priceEl.style.color=(v.compare_at_price>v.price)?'var(--sale)':'';
      if(cmpEl){ if(v.compare_at_price>v.price){cmpEl.hidden=false;cmpEl.textContent=money(v.compare_at_price)} else cmpEl.hidden=true; }
      if(stockEl) stockEl.innerHTML=v.available?'In stock':'<span style="color:var(--mut)">Out of stock</span>';
      if(btn){ btn.disabled=!v.available; btn.textContent=v.available?'Add to basket':'Out of stock'; }
      if(skuEl){ skuEl.hidden=!v.sku; var s=skuEl.querySelector('span'); if(s) s.textContent=v.sku||''; }
      if(v.featured_image&&mainImg){ mainImg.src=v.featured_image.src; mainImg.removeAttribute('srcset'); }
      gradeText(v);
      var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u);
    }
    root.addEventListener('change',function(e){ if(e.target.matches('input[data-option]')) update(); });
    gradeText(current());
    if(form){ form.addEventListener('submit',function(e){ e.preventDefault(); addToCart(idIn.value,1,null,btn); }); }
    root.querySelectorAll('[data-thumb]').forEach(function(b){ b.addEventListener('click',function(){ if(mainImg){mainImg.src=b.getAttribute('data-thumb');mainImg.removeAttribute('srcset');} root.querySelectorAll('[data-thumb]').forEach(function(x){x.removeAttribute('aria-current')}); b.setAttribute('aria-current','true'); }); });
  }
})();
